export const formatPositinosToSkillRates = positions =>
  positions.flatMap(({ skills }) =>
    skills
      .filter(skill => skill.id) // Do not send object for not "existing" tiers in the API payload
      .filter(skill => skill.bill.field.value || skill.pay.field.value)
      .map(skill => ({
        skill_id: skill.id,
        bill: parseFloat(skill.bill.field.value),
        pay: parseFloat(skill.pay.field.value),
      })),
  );
